import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '@/views/login'
import LogQuery from '@/views/LogQuery'
import Category from '@/views/Category'
import Video from '@/views/Video'
import upload from '@/views/upload'
import Aavolunteer from '@/views/Aavolunteer'
import article from '@/views/article'

Vue.use(VueRouter)
const routes = [
    {
        path: '/login',
        name: 'login',
        component: login
    },
    {
        path: '/LogQuery',
        name: 'LogQuery',
        component: LogQuery
    },
    {
        path: '/Category',
        name: 'Category',
        component: Category
    },
    {
        path: '/Video',
        name: 'Video',
        component: Video
    },
    {
        path: '/upload',
        name: 'upload',
        component: upload
    },
    {
        path: '/Aavolunteer',
        name: 'Aavolunteer',
        component: Aavolunteer
    },
    {
        path: '/article',
        name: 'article',
        component: article
    }
]

if (sessionStorage.getItem('uKey') == 1) {
    let defaultRoute = {
        path: '/',
        name: 'Category',
        component: Category
    }
    routes.push(defaultRoute)
}

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
